import React, { Component } from "react";
import { observer } from "mobx-react";

import { Navigate, useParams } from "react-router-dom";

import { useRootStore } from "../../../../hooks/useRootStore";

import "./Quizzer.css";
import QuestionTypeSelector from "./QuestionTypeSelector";

import Grid from "@mui/material/Grid";

import SidebarQuizzer from "../../Component/SidebarQuizzer";

import QuestionHistoryDisplay from "./QuestionHistoryDisplay";
import QuizzerQuizSubjectInfo from "./QuizzerQuizSubjectInfo";
import QuestionDisplay from "./QuestionDisplay";
import SubmitButton from "./SubmitButton";

export class Quizzer extends Component<any, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            selectedAnswer: undefined,
            toSubject: false
        };

        this.editSubject = this.editSubject.bind(this);
        this.getAnswer = this.getAnswer.bind(this);
        this.getQuestion = this.getQuestion.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.setSelectedAnswer = this.setSelectedAnswer.bind(this);
        this.questionType = this.questionType.bind(this);

        this.getQuestionEasy = this.getQuestionEasy.bind(this);
        this.getQuestionRight = this.getQuestionRight.bind(this);
        this.getQuestionWrong = this.getQuestionWrong.bind(this);
    }

    componentDidMount() {
        this.props.rootStore.uiStore.loadQuestionTypes();

        this.props.rootStore.subjectStore.fetchOne(
            this.props.match.params.subject_user,
            this.props.match.params.subject_slug,
        );
        this.getQuestion();
    }

    editSubject() {
        this.setState({
            toSubject: true
        });
    }

    getAnswer() {
        this.props.rootStore.quizzerStore.fetchAnswer(
            this.props.match.params.subject_user,
            this.props.match.params.subject_slug,
            this.props.rootStore.quizzerStore.question,
            this.state.selectedAnswer,
            (...args: any[]) => {}
        );
    }

    getQuestion(params?: any) {
        let options = {};
        let _this = this;
        if (this.props.match.params.object_id) {
            options = {
                object_id: this.props.match.params.object_id
            };
        }

        const defaultParams = {
            has_last_question: false,
        };

        if (!params) {
            params = defaultParams;
        }

        this.props.rootStore.quizzerStore.fetchQuestion(
            this.props.match.params.subject_user,
            this.props.match.params.subject_slug,
            options,
            params,
            (success: any, questionObject: any) => {
                _this.setState({
                    selectedAnswer: undefined,
                })
                if (success && questionObject) {
                    console.log(questionObject.type);
                }
            }
        );
    }

    getQuestionEasy() {
        this.getQuestion({
            has_last_question: true,
            last_question: this.props.rootStore.quizzerStore.question,
            last_question_result: 2,
        });
    }

    getQuestionRight() {
        this.getQuestion({
            has_last_question: true,
            last_question: this.props.rootStore.quizzerStore.question,
            last_question_result: true,
        });
    }

    getQuestionWrong() {
        this.getQuestion({
            has_last_question: true,
            last_question: this.props.rootStore.quizzerStore.question,
            last_question_result: false,
        });
    }

    setSelectedAnswer(selected: string) {
        this.setState({
            selectedAnswer: selected
        });
    }

    handleChange(ev: any, newSelectedQuestionTypes: Array<string>) {
        this.props.rootStore.uiStore.setSelectedQuestionTypes(newSelectedQuestionTypes);
    }

    showAnswer(): boolean {
        const showAnswer = (
            this.props.rootStore.quizzerStore.answer &&
            this.props.rootStore.quizzerStore.answer.show_answer === true
        );

        return showAnswer;
    }

    public render() {
        const params = this.props.match.params;

        if (this.state.toSubject) {
            return (
                <Navigate
                    to={`/modquiz/subjects/${params.subject_user}/${params.subject_slug}/simple_edit`}
                />
            );
        }

        if (!this.props.rootStore.quizzerStore.question) {
            return <div className="container quizzer-foreground"></div>;
        }

        const isLoggedIn = this.props.rootStore.profileStore.isLoggedIn;
        const subject = this.props.rootStore.subjectStore.subjects.get(`${params.subject_user}/${params.subject_slug}`);
        const user_is_done_quizzing_for_today = this.props.rootStore.quizzerStore.user_is_done_quizzing_for_today;
        const percent_complete_today = this.props.rootStore.quizzerStore.quiz_user_subject_tracking.percent_complete_today()

        return (
            <Grid container direction="row">
                <Grid item xs={"auto"} sm={3} md={2}>
                    <SidebarQuizzer
                        hasCreateAccess={isLoggedIn}
                        subject={subject}
                    >
                        {this.props.rootStore.quizzerStore
                            .quiz_user_subject_tracking && (
                            <QuizzerQuizSubjectInfo
                                user_is_done_quizzing_for_today={user_is_done_quizzing_for_today}
                                percent_complete_today={percent_complete_today}
                                questions_total={
                                    this.props.rootStore.quizzerStore.quiz_user_subject_tracking.questions_total
                                }
                                daily_active_percent={
                                    this.props.rootStore.quizzerStore
                                        .quiz_user_subject_tracking
                                        .daily_active_percent
                                }
                                daily_starting_percent={
                                    this.props.rootStore.quizzerStore
                                        .quiz_user_subject_tracking
                                        .daily_starting_percent
                                }
                                daily_questions_left={
                                    this.props.rootStore.quizzerStore
                                        .quiz_user_subject_tracking
                                        .daily_questions_left
                                }
                                daily_questions_total={
                                    this.props.rootStore.quizzerStore
                                        .quiz_user_subject_tracking
                                        .daily_questions_total
                                }
                                total_completion_percent={
                                    this.props.rootStore.quizzerStore
                                        .quiz_user_subject_tracking
                                        .total_completion_percent
                                }
                            />
                        )}
                    </SidebarQuizzer>
                </Grid>
                <Grid item xs={12} sm={9} md={10} className="quizzer-main-column">
                    <div className="quizzer-topbar">
                        <QuestionTypeSelector
                            questionTypes={
                                this.props.rootStore.uiStore.questionTypes
                            }
                            selectedQuestionTypes={
                                this.props.rootStore.uiStore
                                    .selectedQuestionTypes
                            }
                            handleChange={this.handleChange}
                            adaptable={this.props.rootStore.uiStore.adaptable}
                            setAdaptable={this.props.rootStore.uiStore.setAdaptable}
                        />
                    </div>
                    <div className="quizzer-foreground">
                        <QuestionDisplay
                            questionType={this.questionType()}
                            setSelectedAnswer={this.setSelectedAnswer}
                            selectedAnswer={this.state.selectedAnswer}
                            showAnswer={this.showAnswer()}
                            subjectUser={this.props.match.params.subject_user}
                            subjectSlug={this.props.match.params.subject_slug}
                            question={
                                this.props.rootStore.quizzerStore.question
                            }
                            answer={this.props.rootStore.quizzerStore.answer}
                            showLoader={this.props.rootStore.quizzerStore.state == "pending"}
                            showError={
                                this.props.rootStore.quizzerStore.state ==
                                "error"
                            }
                            errorSource={
                                this.props.rootStore.quizzerStore.errorSource
                            }
                            errorTitle={
                                this.props.rootStore.quizzerStore.errorTitle
                            }
                            errorDetail={
                                this.props.rootStore.quizzerStore.errorDetail
                            }
                        />

                        {this.props.rootStore.quizzerStore.question
                            .historyResults && (
                                <QuestionHistoryDisplay
                                history={this.props.rootStore.quizzerStore.question.historyResults()}
                            />

                        )}

                        <SubmitButton
                            editSubject={this.editSubject}
                            showAnswer={this.showAnswer()}
                            questionType={this.questionType()}
                            getQuestionEasy={this.getQuestionEasy}
                            getQuestionRight={this.getQuestionRight}
                            getQuestionWrong={this.getQuestionWrong}
                            getQuestion={this.getQuestion}
                            getAnswer={this.getAnswer}
                            showError={
                                this.props.rootStore.quizzerStore.state ==
                                "error"
                            }
                            subject_user={this.props.match.params.subject_user}
                            subject_slug={this.props.match.params.subject_slug}
                            object_id={this.getObjectID()}
                        />
                    </div>
                </Grid>
            </Grid>
        );
    }

    private questionType = () => this.props.rootStore.quizzerStore.question.type;

    private getObjectID(): string {
        const b = this.props.rootStore.quizzerStore.question.object_id;
        return b;
    }
}

const ObservedQuizzer = observer(Quizzer);

export default function QuizzerRoute() {
    const params = useParams<{
        subject_user: string;
        subject_slug: string;
        object_id?: string;
    }>();
    const rootStore = useRootStore();

    return <ObservedQuizzer rootStore={rootStore} match={{ params }} />;
}
